import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const ReceiptlessReturns: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--receiptless-returns')}
    viewBox="0 0 26 26"
    width="26"
    height="26"
    xmlns="http://www.w3.org/2000/svg"
    data-icon={icon}
  >
    <g transform="translate(-4 -7)" fill="none" fillRule="evenodd">
      <g fill="#000" fillRule="nonzero">
        <path d="M13.625 7.125V14.5h.75V7.875h14.25v23.75h-14.25V23.5h-.75v8.875h15.75V7.125z" />
        <path d="M17.3 22.045l-.455-1.23c-1.02-2.745-3.535-4.625-6.47-4.865v-3.975l-6.165 6.14 6.165 6.14V19.79c3.215-.585 5.86 1.43 5.89 1.45l1.035.805zM9.915 19.12l-.29.065v3.265l-4.35-4.335 4.35-4.335v2.885l.36.015c2.36.085 4.455 1.335 5.62 3.28-1.215-.63-3.305-1.385-5.69-.84zM19 17.625h5v1h-5zM19 21.125h5v1h-5zM19 14.125h5v1h-5zM19 24.625h5v1h-5z" />
      </g>
    </g>
  </svg>
);

export default ReceiptlessReturns;
